export const isId = (columnId) => {
  return (id) => {
    return id === columnId
  }
}
